import { createRouter, createWebHashHistory, type RouteRecordRaw } from 'vue-router'
import { useAuthStore } from '../stores/auth'
import type { Role } from '../types'

declare module 'vue-router' {
  interface RouteMeta {
    title: string
    requiresAuth?: boolean
    roles?: Role[]
    fullPage?: boolean
  }
}

const routes: RouteRecordRaw[] = [
  { path: '/login', component: () => import('../views/LoginView.vue'), meta: { title: 'auth.title', fullPage: true } },
  { path: '/orders', component: () => import('../views/OrdersView.vue'), meta: { title: 'order.listTitle', requiresAuth: true } },
  { path: '/orders/create', component: () => import('../views/CreateOrderView.vue'), meta: { title: 'order.createTitle', requiresAuth: true } },
  { path: '/orders/:id', component: () => import('../views/OrderDetailView.vue'), meta: { title: 'order.detailTitle', requiresAuth: true } },
  { path: '/parts-orders', component: () => import('../views/PartsOrdersView.vue'), meta: { title: 'inventoryOrder.title', requiresAuth: true, roles: ['admin', 'brazil', 'naitteng'] } },
  { path: '/parts-orders/create', component: () => import('../views/CreatePartsOrderView.vue'), meta: { title: 'inventoryOrder.create', requiresAuth: true, roles: ['admin', 'naitteng'] } },
  { path: '/parts-orders/:id', component: () => import('../views/PartsOrderDetailView.vue'), meta: { title: 'inventoryOrder.detail', requiresAuth: true, roles: ['admin', 'brazil', 'naitteng'] } },
  { path: '/warehouse', component: () => import('../views/WarehouseView.vue'), meta: { title: 'warehouse.title', requiresAuth: true, roles: ['admin', 'brazil', 'naitteng'] } },
  { path: '/settings/account', component: () => import('../views/AccountView.vue'), meta: { title: 'account.title', requiresAuth: true, roles: ['admin'] } },
  { path: '/settings/process', component: () => import('../views/ProcessView.vue'), meta: { title: 'process.title', requiresAuth: true, roles: ['admin'] } },
  { path: '/import', component: () => import('../views/DataView.vue'), meta: { title: 'data.title', requiresAuth: true, roles: ['admin'] } },
  { path: '/', redirect: '/orders' },
  { path: '/:pathMatch(.*)*', redirect: '/orders' },
]

const router = createRouter({
  history: createWebHashHistory(),
  routes,
  scrollBehavior: () => ({ top: 0 }),
})

router.beforeEach(async (to) => {
  const auth = useAuthStore()
  await auth.initialize()
  if (to.meta.requiresAuth && !auth.isAuthenticated) return { path: '/login', query: { redirect: to.fullPath } }
  if (to.path === '/login' && auth.isAuthenticated) return '/orders'
  if (to.meta.roles?.length && (!auth.role || !to.meta.roles.includes(auth.role))) return '/orders'
})

export default router
